import React from 'react'
import User from '../../User'
import ActivityContent from './ActivityContent'
import ActivityGroup from 'components/ActivityGroup'

export class Activity extends React.Component {
  render () {
    return (
      <ActivityGroup
        {...this.props}
        userComponent={User}
        contentComponent={ActivityContent}
      />
    )
  }
}

export default Activity

